// Mode descriptions and legal references helper
export const getModeDescription = (selectedMode) => {
  let description = '';
  let basisPoints = [];
  let legalRef = '';
  
  switch (selectedMode.id) {
    case 'competitive-bidding':
      description = 'Standard competitive bidding process ensuring transparency and fairness through open competition.';
      basisPoints = [
        'Requirements are clear and well-defined',
        'Promotes open competition and best value',
        selectedMode.verificationCriteria && selectedMode.verificationCriteria !== 'None' ? selectedMode.verificationCriteria : 'Full RA 12009 process with 7-day posting'
      ];
      legalRef = 'RA 12009, Article 4, Section 27 | IRR Rule 4, Section 27';
      break;
      
    case 'limited-source-bidding':
      description = 'Competitive process limited to pre-qualified suppliers due to specialized nature of requirement.';
      basisPoints = [
        'Highly specialized goods/services/infrastructure',
        'Only limited number of capable suppliers',
        selectedMode.verificationCriteria || 'List of qualified sources must be documented',
        'Must justify why general competition is not feasible'
      ];
      legalRef = 'RA 12009, Article 4, Section 28 | IRR Rule 4, Section 28';
      break;
      
    case 'competitive-dialogue':
      description = 'Two-stage competitive process for complex requirements where specifications cannot be fully defined upfront.';
      basisPoints = [
        'Complex or innovative nature',
        'Specifications cannot be fully developed initially',
        selectedMode.verificationCriteria || 'Dialogue materially improves quality',
        'Meets Section 29 triggers for complexity'
      ];
      legalRef = 'RA 12009, Article 4, Section 29 | IRR Rule 4, Section 29';
      break;
      
    case 'unsolicited':
      description = 'Procurement based on unsolicited proposal with bid matching mechanism.';
      basisPoints = [
        'New technology or innovative concept',
        'Subject to bid matching process',
        selectedMode.verificationCriteria || 'Compliance with new concept/technology criteria',
        'Offer completeness and evaluation required'
      ];
      legalRef = 'RA 12009, Article 4, Section 30 | IRR Rule 4, Section 30';
      break;
      
    case 'direct-contracting':
      description = 'Direct procurement from a single source due to proprietary/exclusive nature.';
      basisPoints = [
        'Proprietary or IP-protected items',
        'Only one legitimate source exists',
        selectedMode.verificationCriteria || 'Proof of exclusivity required',
        'No viable alternatives available'
      ];
      legalRef = 'RA 12009, Article 4, Section 31 | IRR Rule 4, Section 31';
      break;
      
    case 'direct-acquisition':
      description = 'Direct purchase of off-the-shelf items within very low-value threshold.';
      basisPoints = [
        'ABC ≤ ₱200,000 (or adjustable threshold)',
        'Simple off-the-shelf items',
        selectedMode.verificationCriteria || 'From reputable source with proper invoice',
        'COA-acceptable documentation'
      ];
      legalRef = 'RA 12009, Article 4, Section 32 | IRR Rule 4, Section 32';
      break;
      
    case 'repeat-order':
      description = 'Additional procurement of similar items from recent competitive bidding.';
      basisPoints = [
        'Original procurement via competitive bidding',
        'Within 25% quantity and 6 months limit',
        selectedMode.verificationCriteria || 'Price same or lower than original',
        'Supplier still capable of delivery'
      ];
      legalRef = 'RA 12009, Article 4, Section 33 | IRR Rule 4, Section 33';
      break;
      
    case 'small-value':
      description = 'Simplified procurement process for small-value requirements within SVP threshold.';
      basisPoints = [
        'ABC within Small Value Procurement ceiling',
        'Simplified documentation requirements',
        selectedMode.verificationCriteria || 'At least 3 RFQs required',
        'Proper posting and no contract splitting'
      ];
      legalRef = 'RA 12009, Article 4, Section 34 | IRR Rule 4, Section 34';
      break;
      
    case 'two-failed-bidding':
      description = 'Negotiated procurement after two failed competitive bidding attempts.';
      basisPoints = [
        'Two previous competitive bidding attempts failed',
        'Requirements remain valid and necessary',
        selectedMode.verificationCriteria || 'Documentation of failed biddings required',
        'Price negotiation within approved budget'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(a) | IRR Rule 4, Section 35.1';
      break;
      
    case 'emergency':
      description = 'Expedited procurement for emergency situations requiring immediate action.';
      basisPoints = [
        'Imminent danger to life or property',
        'Need to restore vital public services',
        selectedMode.verificationCriteria || 'Calamity/emergency declaration required',
        'Link of procurement to urgent need must be clear'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(b) | IRR Rule 4, Section 35.2';
      break;
      
    case 'takeover':
      description = 'Negotiated - Take-over of Contracts for incomplete project.';
      basisPoints = [
        'Previous contractor failed, abandoned, or was terminated',
        'Immediate continuation needed to prevent damage or delay',
        'Urgent continuation of critical service or project required',
        selectedMode.verificationCriteria || 'Procuring entity must assume contractor responsibilities'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(c) | IRR Rule 4, Section 35.3';
      break;
      
    case 'adjacent-contiguous':
      description = 'Negotiated procurement for works adjacent or contiguous to ongoing project.';
      basisPoints = [
        'Physically adjacent to ongoing project',
        'Related scope of work',
        selectedMode.verificationCriteria || 'Physical contiguity and scope relation documented',
        'Same or lower unit prices as original contract'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(d) | IRR Rule 4, Section 35.4';
      break;
      
    case 'agency-to-agency':
      description = 'Procurement from another government agency with legal mandate and capacity.';
      basisPoints = [
        'Servicing agency has legal mandate',
        'Agency has technical capacity and track record',
        selectedMode.verificationCriteria || 'Capacity certification required',
        'No subcontracting of main scope'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(e) | IRR Rule 4, Section 35.5';
      break;
      
    case 'scientific-scholarly':
      description = 'Procurement requiring specialized scientific, scholarly, or artistic expertise.';
      basisPoints = [
        'Specialized scientific/artistic nature',
        'Available only from particular source',
        selectedMode.verificationCriteria || 'Proof of exclusive expertise or IP',
        'Technical justification documented'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(f) | IRR Rule 4, Section 35.6';
      break;
      
    case 'highly-technical-consultants':
      description = 'Negotiated procurement for highly technical consultants.';
      basisPoints = [
        'Work is highly technical or confidential',
        'Trust and confidence basis',
        selectedMode.verificationCriteria || '1-year term limits apply',
        'Proper justification required'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(g) | IRR Rule 4, Section 35.7';
      break;
      
    case 'ngo-participation':
      description = 'Negotiated procurement through NGO participation.';
      basisPoints = [
        'Funds earmarked for NGO by law, ordinance, or policy',
        'NGO has demonstrable capacity and track record',
        '3-day posting required',
        'MOA and capability documentation required'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(j) | IRR Rule 4, Section 35.10';
      break;
      
    case 'community-participation':
      description = 'Negotiated procurement with community participation.';
      basisPoints = [
        'Simple infrastructure or goods for community',
        'Community groups properly organized',
        selectedMode.verificationCriteria || 'Community capacity and roles defined',
        'Within threshold limits'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(i) | IRR Rule 4, Section 35.9';
      break;
      
    case 'un-agencies':
      description = 'Negotiated procurement through UN Agencies/IOs/IFIs.';
      basisPoints = [
        'Specialized requirements from UN/IO/IFI',
        'Comparative advantage demonstrated',
        selectedMode.verificationCriteria || 'Specialization documented',
        'Alignment with international commitments'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(k) | IRR Rule 4, Section 35.11';
      break;
      
    case 'lease-property':
    case 'lease-venue':
      description = 'Negotiated procurement for lease of real property or venue.';
      basisPoints = [
        'Government lease preferred if available',
        'Private lease if more economical',
        selectedMode.verificationCriteria || 'Limited available properties meet requirements',
        'Fair price determination'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(l) | IRR Rule 4, Section 35.12';
      break;
      
    case 'defense-cooperation':
      description = 'Negotiated Procurement – Defense Cooperation Agreement and Inventory-Based Items for defense-related procurements.';
      basisPoints = [
        'Defense or national security item',
        'Under defense cooperation agreement',
        selectedMode.verificationCriteria || 'DND approvals required',
        'Link to defense modernization'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(m) | IRR Rule 4, Section 35.13';
      break;
      
    case 'direct-retail':
      description = 'Negotiated Procurement - Direct Retail Purchase of Petroleum Fuel, Oil and Lubricant Products (POL), Electronic Charging Devices, and Online Subscription. This mode is EXCLUSIVELY applicable to these specific items only and cannot be used for any other products.';
      basisPoints = [
        'ONLY applicable to: POL (Petroleum Fuel, Oil, Lubricants), Electronic Charging Devices, or Online Subscriptions',
        'Cannot be used for any other products or items',
        'Items needed for daily operations and not available in PS-DBM',
        selectedMode.verificationCriteria || 'Within threshold limits; item must fall under POL, electronic charging, or online subscription'
      ];
      legalRef = 'RA 12009, Article 4, Section 35(n) | IRR Rule 4, Section 35.14';
      break;
      
    case 'sagip-saka':
      description = 'Direct procurement under Sagip Saka Act.';
      basisPoints = [
        'Agricultural and fishery products',
        'From accredited farmers/fisherfolk cooperatives',
        selectedMode.verificationCriteria || 'Under RA 11321 (Sagip Saka Act)',
        'Support for local agriculture'
      ];
      legalRef = 'GPPB Circular No. 02-2025 | RA 12009: Article IV, Section 35 | RA 12009: Rule IV, Section 35';
      break;
      
    case 'international-events':
      description = 'Negotiated Procurement for International Events, Conferences, Summits, or Activities Hosted by the Philippine Government.';
      basisPoints = [
        'International event formally hosted by Philippine Government (e.g., ASEAN, APEC, SEA Games, UN meetings)',
        'Existing procurement modes are impracticable due to security, protocol, or operational requirements',
        selectedMode.verificationCriteria || 'Strict documentation of necessity, scope, and value-for-money',
        'Compliance with international obligations, security standards, and diplomatic protocols'
      ];
      legalRef = 'GPPB Resolution No. 01-2026 | RA 12009, Article 4, Section 35 | IRR Rule 4, Section 35';
      break;
      
    case 'direct-sales':
      description = 'Direct sales from another government contract.';
      basisPoints = [
        'Non-CSE supplied under another agency contract',
        'Within 6 months of delivery',
        selectedMode.verificationCriteria || 'Delivery acceptance and supplier capability',
        'Same or lower price as original contract'
      ];
      legalRef = 'RA 12009, Article 4, Section 36 | IRR Rule 4, Section 36';
      break;
      
    case 'sti':
      description = 'Direct procurement for Science & Technology and Innovation.';
      basisPoints = [
        'R&D or innovation-related procurement',
        'Exclusive use in S&T activities',
        selectedMode.verificationCriteria || 'Confirmation of eligible R&D activity',
        'IP and ownership alignment'
      ];
      legalRef = 'RA 12009, Article 4, Section 37 | IRR Rule 4, Section 37';
      break;
      
    case 'cse-psdbm':
      description = 'Procurement of Common-Use Supplies and Equipment from PS-DBM.';
      basisPoints = [
        'CSE items available in PS-DBM catalog',
        'Mandatory centralized procurement',
        selectedMode.verificationCriteria || 'Verification of CSE listing',
        'No justification for exemption'
      ];
      legalRef = 'RA 12009, Article 4, Section 40 | IRR Rule 4, Section 40';
      break;
      
    default:
      description = selectedMode.condition || 'Specialized procurement mode based on specific conditions.';
      basisPoints = [
        selectedMode.scenario || 'Based on assessment results',
        selectedMode.verificationCriteria || 'Follow RA 12009 requirements',
        `Risk Level: ${selectedMode.riskLevel}`,
        'Ensure compliance with all legal requirements'
      ];
      legalRef = 'RA 12009 - Applicable Sections';
  }
  
  // Remove duplicates and empty entries from basisPoints
  // Helper function to extract key phrases for comparison
  const extractKeyPhrases = (text) => {
    // Normalize the text: lowercase, remove punctuation, normalize spaces
    let normalized = text.toLowerCase()
      .replace(/sec\./g, 'section')  // Normalize "Sec." to "section"
      .replace(/[\/,;:]/g, ' ')       // Replace separators with spaces
      .replace(/[^\w\s]/g, '')        // Remove other punctuation
      .replace(/\s+/g, ' ')           // Normalize whitespace
      .trim();
    
    // Extract key terms (words longer than 2 chars)
    return normalized.split(' ').filter(word => word.length > 2);
  };
  
  // Check if two texts are semantically similar (share significant key phrases)
  const areSimilar = (text1, text2) => {
    const phrases1 = extractKeyPhrases(text1);
    const phrases2 = extractKeyPhrases(text2);
    
    // Count matching key phrases
    const matches = phrases1.filter(p => phrases2.includes(p));
    
    // If more than 50% of the shorter text's phrases match, consider them similar
    const minLength = Math.min(phrases1.length, phrases2.length);
    if (minLength === 0) return false;
    
    return matches.length >= Math.ceil(minLength * 0.5);
  };
  
  const seenTexts = [];
  basisPoints = basisPoints.filter(point => {
    if (!point || point.trim() === '' || point === 'None') return false;
    
    // Check for exact or semantic duplicates
    for (const existing of seenTexts) {
      if (areSimilar(point, existing)) {
        // Keep the longer/more detailed one - skip this shorter one
        if (point.length <= existing.length) return false;
        // If current is longer, remove the existing shorter one
        const idx = seenTexts.indexOf(existing);
        if (idx > -1) seenTexts.splice(idx, 1);
      }
    }
    
    seenTexts.push(point);
    return true;
  });
  
  return { description, basisPoints, legalRef };
};
